module.exports = __webpack_public_path__ + "static/media/PB_greet.506178a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PB_greet.png
// module id = 1271
// module chunks = 0